import React from 'react';
import { Heart, HelpCircle, Scale, Users, Building2 } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-white border-t">
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center space-y-4">
          <div className="flex items-center space-x-2 text-gray-600">
            <span>Made with</span>
            <Heart className="h-4 w-4 text-red-500" />
            <span>for food lovers everywhere</span>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
            <Link 
              to="/faq"
              className="flex items-center space-x-2 text-gray-500 hover:text-orange-500 transition"
            >
              <HelpCircle className="h-5 w-5" />
              <span>FAQ</span>
            </Link>
            <Link 
              to="/legal"
              className="flex items-center space-x-2 text-gray-500 hover:text-orange-500 transition"
            >
              <Scale className="h-5 w-5" />
              <span>Impressum</span>
            </Link>
            <Link 
              to="/team"
              className="flex items-center space-x-2 text-gray-500 hover:text-orange-500 transition"
            >
              <Users className="h-5 w-5" />
              <span>Unser Team</span>
            </Link>
            <Link 
              to="/restaurant-signup"
              className="flex items-center space-x-2 text-gray-500 hover:text-orange-500 transition"
            >
              <Building2 className="h-5 w-5" />
              <span>Lokal registrieren</span>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;